import React, { Component } from 'react';
import Select from '../../forms/select';
import { FIELDS } from '../../../data/fields';

class CustomFieldLine extends Component {
  state = {};
  render() {
    const { options, field, onFieldChange, onFieldDelete } = this.props;
    const nameMetaKey = 'key_' + field.id;
    const nameMetaValue = 'value_' + field.id;

    return (
      <div className="customfield-line">
        <div className="row middle-xs">
          <div className="col-xs-12 col-md-5">
            <Select
              label="Meta key"
              name={nameMetaKey}
              value={field.key}
              options={options}
              onChange={onFieldChange}
            />
          </div>
          <div className="col-xs-12 col-md-5">
            <Select
              label="Meta value"
              name={nameMetaValue}
              value={field.value}
              options={FIELDS}
              onChange={onFieldChange}
            />
          </div>
          <div className="col-xs-12 col-md-2">
            <button
              type="button"
              className="button"
              onClick={() => onFieldDelete(field.id)}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomFieldLine;



// WEBPACK FOOTER //
// ./src/components/settings/optionblocks/customFieldLine.jsx